import {
  Collection,
  Filter,
  ProductConnection,
  ProductCollectionSortKeys,
  ProductFilter,
} from '@shopify/hydrogen-react/storefront-api-types';
import { COLLECTION_FILTER_GET_QUERY, COLLECTION_GET_PRODUCTS } from './queries';
import { prepareExclusiveFilter } from '../exclusiveProducts';
import { getAvailableFilters } from '../filters';
import { executeGraphQLQuery } from '../storefrontClient';
import { prepareAvailabilityFilter } from '../availabilityFilter';

export const getCollectionFilters = async (
  handle: string = ''
): Promise<Collection | undefined> => {
  try {
    const filters = prepareAvailabilityFilter([]);
    let collection = await executeGraphQLQuery(COLLECTION_FILTER_GET_QUERY, {
      handle,
      filters,
    });
    collection.data.collection.products.filters = getAvailableFilters(
      collection.data.collection.products.filters
    );
    return Promise.resolve(collection.data.collection);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCollectionProducts = async (
  handle: string = '',
  cursor: { after?: string | null; before?: string | null } = {},
  filters: ProductFilter[],
  sortKey?: ProductCollectionSortKeys,
  reverse?: boolean,
  first: number = 24
): Promise<ProductConnection | undefined> => {
  try {
    filters = prepareExclusiveFilter(filters);
    filters = prepareAvailabilityFilter(filters);

    const isBackward = !!cursor.before;
    const variables = {
      handle,
      filters,
      sortKey,
      reverse,
      first: isBackward ? null : first,
      last: isBackward ? first : null,
      after: cursor.after ?? null,
      before: cursor.before ?? null,
    };

    const collections = await executeGraphQLQuery(COLLECTION_GET_PRODUCTS, variables);
    return Promise.resolve(collections.data.collection.products);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAllFilters = async (handle: string = ''): Promise<Filter[] | undefined> => {
  try {
    const filters = prepareAvailabilityFilter([]);
    const collection = await executeGraphQLQuery(COLLECTION_FILTER_GET_QUERY, {
      handle,
      filters,
    });
    collection.data.collection.products.filters = getAvailableFilters(
      collection.data.collection.products.filters
    );
    return Promise.resolve(collection.data.collection.products.filters);
  } catch (error) {
    return Promise.reject(error);
  }
};
